import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: boolean
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: false
};

const likeNewsSlice = createSlice({
  name: "getAvatar",
  initialState,
  reducers: {

    likeNewsStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    likeNewsSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    likeNewsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    setupData:  (state, action) => {
      state.data = action.payload.status;
    },
  },
});

export const { setupData, likeNewsStart, likeNewsSuccess, likeNewsFailed } =
  likeNewsSlice.actions;

export default likeNewsSlice.reducer;
